/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import $ from 'jquery';
import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { InlineEditableColumnPrompt, inlineEditSave } from '@bingads-webui-campaign/summary-grid-helper';
import { Campaign } from '@bingads-webui-campaign/campaign-ui-schemas';
import appConfig from '@bingads-webui-component-legacy/config/index';
import jsData from '@bingads-webui-component-legacy/js-data-campaign/index';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import campaignTemplate from './campaign.pug';

const permissions = appConfig.get('Permissions');

export class CampaignColumn extends CampaignuiBaseColumn {
  constructor({
    i18n, scope, view,
  }) {
    super({
      name: 'Name',
      property: _.compact([
        'Name',
        'Id',
        'Labels', // for labels menu
        permissions.IsBAACompetitionBSCAuctionInsightsEnabled && 'CampaignType',
        permissions.IsExperimentsEnabled && 'BaseCampaignName',
        permissions.IsSmartShoppingCampaignEnabled && 'CampaignSubType',
      ]),
      title: i18n.getString('ColumnName_Campaign'),
      sortable: 'Name',
      editable: true,
      type: 'string',
      bodyClasses: ['grid-column-Campaign'],
      group: 'freezing',
    });

    this.scope = scope;
    this.i18n = i18n;
    this.view = view;
  }

  pickProperty(item) {
    const { customerId: cid, accountId: aid } = this.scope;
    const {
      Name: name,
      Id: cmpid,
      $total,
      BaseCampaignName,
    } = item;
    const isSmartCampaign = item.CampaignType === 'Smart';
    const isPMaxCampaign = item.CampaignType === 'PerformanceMax';
    const isAppCampaign = item.CampaignType === 'App';

    let href = '';

    if (isSmartCampaign) {
      href = item.DeliveryStatus === 'CampaignInProgress' ?
        `/campaign/Smart?cid=${cid}#/CreateCampaign/${cmpid}` :
        `/campaign/Smart?cid=${cid}#/campaign/${cmpid}`;
    } else if (isPMaxCampaign || isAppCampaign) {
      href = `/campaign/vnext/overview?aid=${aid}&cid=${cid}&campaignId=${cmpid}`;
    } else {
      href = `/campaign/vnext/adgroups?aid=${aid}&cid=${cid}&campaignId=${cmpid}`;
    }

    let ariaLabel = this.i18n.getString('Click to scope to campaign {{campaignName}}', { campaignName: name });
    let className = '';

    if (BaseCampaignName) {
      ariaLabel = this.i18n.getString('Click to scope to experiment {{experimentName}}', { experimentName: name });
      className = 'experiment-name';
    }

    return {
      $total,
      name,
      href,
      Id: cmpid,
      skipScopeNavigation: isSmartCampaign,
      Status: item.DeliveryStatus,
      BaseCampaignName,
      isForVNext: true,
      ariaLabel,
      className,
    };
  }

  get template() { return campaignTemplate; }

  onPrompt({
    event, item, newPosition,
  }) {
    if ($(event.target).is('a')) {
      return undefined;
    }

    return InlineEditableColumnPrompt({
      position: newPosition,
      item,
      view: this.view,
      i18n: this.i18n,
      fieldName: 'Name',
      schema: Campaign,
      saveModel: (updated, editorView) => inlineEditSave(
        {
          id: item.Id,
          fieldName: 'Name',
          updatedItem: updated,
        },
        {
          view: this.view,
          resource: jsData.Campaign,
          i18n: this.i18n,
          i18nErrors,
          editorView,
          editorViewCallbackAfterUpdate: () => {
            editorView.trigger('save', updated);

            // Since the currently edited Campaign may also be the BaseCampaign of
            // other Experimental Campaigns in this grid, check and update.
            _.each(this.view.grid.gridView.itemArray, (rowItem) => {
              if (rowItem.BaseCampaignName === item.Name) {
                const updatedRowItem = _.defaults({
                  BaseCampaignName: updated.Name,
                }, rowItem);

                this.view.grid.gridView.trigger('didEdit', updatedRowItem);
              }
            });

            // update wunderbar
            const response = [{
              Id: item.Id,
              Name: updated.Name,
            }];

            window.App.trigger('campaignUpdated', { data: response });
          },
          customBlockerTarget: '.campaigns-page',
        }
      ),
    });
  }
}
